// Keep existing checkout links working while Pricing is the public page URL.
export { default, getServerSideProps } from "../get-access";
